/** Неизвестный результат удаления/переименования требует обновления списка. */
import { abortableDelay } from '../../services/abort.ts'
import { waitForTask } from '../../services/task.ts'
import { FileOperationError } from './model.ts'

export async function waitForFileTask(
    read: (signal: AbortSignal) => Promise<Response>,
    signal: AbortSignal,
    wait = abortableDelay,
    maxPolls = 300,
): Promise<void> {
    const result = await waitForTask(read, signal, wait, maxPolls)
    if (result === 'done') return

    throw new FileOperationError(result === 'failed' ? 'failed' : 'unconfirmed')
}
